module.exports = __webpack_public_path__ + "img/checkin.fad20766.svg";